import React from 'react';
import { Card, Typography, Alert, Divider } from 'antd';
import { AIAnalysisResult } from '../../Questionnaire/NewAI/shared/types';
import { t } from './renderingHelpers';
import AIAnalysisResultPrompt2 from './AIAnalysisResultPrompt2';

const { Title, Paragraph, Text } = Typography;

interface AIAnalysisResultPrompt3Props {
  result: AIAnalysisResult;
  lang: 'en' | 'nl';
  clientName?: string;
  professionalName?: string;
}

const AIAnalysisResultPrompt3: React.FC<AIAnalysisResultPrompt3Props> = ({ 
  result, 
  lang, 
  clientName, 
  professionalName 
}) => {
  return (
    <>
      <Alert
        message={t(lang, 'prompt3Analysis')}
        description={t(lang, 'prompt3InstructionsDetail')}
        type="info"
        showIcon
        style={{ marginBottom: 24 }}
      />

      {/* Display the Prompt 2 base analysis that Prompt 3 builds upon */}
      <Card 
        title={
          <span style={{ fontSize: '14px', fontWeight: 'normal' }}>
            {t(lang, 'prompt2Results')}
          </span>
        }
        size="small"
        style={{ marginBottom: 24, backgroundColor: '#fafafa' }}
      >
        <AIAnalysisResultPrompt2 
          result={result} 
          lang={lang} 
          clientName={clientName || result['client-name']}
          professionalName={professionalName || result['professional-name']}
        />
      </Card>

      <Divider />

      {/* Prompt 3 Specific Results Section */}
      <div style={{ marginTop: 24 }}>
        <Title level={4}>{t(lang, 'prompt3Results')}</Title>
        
        {/* TODO: Add Prompt 3 specific fields here when backend provides the structure */}
        {/* For now, display any additional fields that are not part of standard Prompt 2 */}
        {result.A6 && (
          <Card size="small" style={{ marginBottom: 16 }}>
            <div style={{ marginBottom: 12 }}>
              <Text strong>{t(lang, 'adviceCore')}</Text>
              <Paragraph style={{ marginTop: 8, backgroundColor: '#f5f5f5', padding: '12px', borderRadius: '6px' }}>
                {result.A6.advice_core}
              </Paragraph>
            </div>
            
            {result.A6.advice_details && (
              <div>
                <Text strong>{t(lang, 'adviceDetails')}</Text>
                <Paragraph style={{ marginTop: 8 }}>
                  {result.A6.advice_details}
                </Paragraph>
              </div>
            )}
          </Card>
        )}

        {/* Display any other Prompt 3 specific data */}
        <Alert
          message={lang === 'en' ? 'Transcription Analysis' : 'Transcriptie Analyse'}
          description={
            lang === 'en' 
              ? 'This analysis incorporates insights from the uploaded consultation transcription, building upon the foundational Prompt 2 analysis shown above.'
              : 'Deze analyse bevat inzichten uit de geüploade consulttranscriptie, voortbouwend op de fundamentele Prompt 2-analyse hierboven.'
          }
          type="success"
          showIcon
        />
      </div>
    </>
  );
};

export default AIAnalysisResultPrompt3;
